import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import classes from "./UploadFormStep.module.css"
import Moment from 'moment';
import { onKeyDown } from "../../../../../service";

const UploadFormStep = ({ classification, setUploadStep, selectedProject, setSelectedProject, tabText, setAddItem }) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("")
    // const [tags, setTags] = useState("")

    const texts = useSelector(state => state.translate.texts);

    useEffect(() => {
        if (selectedProject) {
            setName(selectedProject.name || '')
            setDescription(selectedProject.description || '')
            // setTags(selectedProject?.keywords || '')
        }
    }, [selectedProject])

    const handleContinue = () => {
        setSelectedProject({ ...selectedProject, name: name, description: description })
        let data = {
            name: name,
            description: description,
            // keywords: tags,
            contentType: 1,
            externalId: selectedProject.id,
            lang: selectedProject.ide?.lang ? selectedProject.ide?.lang : "he",
            classification: classification,
            contentData: JSON.stringify({ Ide: selectedProject.ide })
        }
        setAddItem(data)
        setUploadStep(3)
    }

    return (
        <div className={classes.FormPopup}>
            <div className={classes.Form}>
                <div className={classes.LastChangedDate}> {texts.recentlySaved} {Moment(selectedProject.createdDate).format('DD.MM.YY')}   </div>
                <div className={`${classes.InputWarrper} ${classes.NameWarrper}`}>
                    <div className={classes.Label}> {texts.name}</div>
                    <input className={classes.Input} value={name} name="Name" onChange={e => setName(e.target.value)} />
                </div>
                <div className={classes.InputWarrper}>
                    <div className={classes.Label}> {texts.description}</div>
                    <input className={`${classes.Input} ${classes.InputDesc}`} value={description} name="Description" onChange={e => setDescription(e.target.value)} />
                </div>
                {/* <div className={classes.InputWarrper}>
                    <div className={classes.Label}> {texts.tags}</div>
                    <input className={classes.Input} value={tags} name="Tags" onChange={e => setTags(e.target.value)} placeholder={`${texts.tagsPlaceholder1} ${tabText} ${texts.tagsPlaceholder2}`} />
                </div> */}
            </div>
            <div className={classes.ContinueBtn} onClick={() => { handleContinue() }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleContinue())}> {texts.continue}</div>
        </div>
    )
}
export default UploadFormStep